export default "__VITE_ASSET__Dkx0z145__"